import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { api } from '../api/client.js';
import { setToken } from '../services/auth.js';

export default function AcceptInvite() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [docs, setDocs] = useState({ documents: [], checks: [] });
  const [ticked, setTicked] = useState({ terms: false, privacy: false });

  useEffect(() => {
    api.get('/auth/consent/documents').then(({ data }) => setDocs(data.data)).catch(() => {});
  }, []);

  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!token) {
      setError('Chybí token pozvánky.');
      return;
    }

    if (password.length < 8) {
      setError('Heslo musí mít alespoň 8 znaků.');
      return;
    }

    if (password !== confirm) {
      setError('Hesla se neshodují.');
      return;
    }

    if (!ticked.terms || !ticked.privacy) {
      setError('Bez obou potvrzení se do Drillu nedostaneš. Když s něčím nesouhlasíš, řeš to s JCH.');
      return;
    }

    setSubmitting(true);

    try {
      const { data } = await api.post('/auth/accept-invite', { token, password, terms: true, privacy: true });
      setToken(data.data.token);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Pozvánku se nepodařilo potvrdit.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <div className="auth">
        <h1 className="auth__title">Neplatná pozvánka</h1>
        <p className="auth__subtitle">Tento odkaz neobsahuje platný token pozvánky.</p>
        <Link to="/login" className="button button--primary">Přejít na přihlášení</Link>
      </div>
    );
  }

  return (
    <div className="auth">
      <h1 className="auth__title">Nastavení hesla</h1>
      <p className="auth__subtitle">Vytvořte si nové heslo pro dokončení účtu.</p>

      <form className="auth__form" onSubmit={handleSubmit}>
        <label className="auth__label">
          Nové heslo
          <input
            className="auth__input"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="new-password"
            required
          />
        </label>

        <label className="auth__label">
          Potvrdit heslo
          <input
            className="auth__input"
            type="password"
            value={confirm}
            onChange={(event) => setConfirm(event.target.value)}
            autoComplete="new-password"
            required
          />
        </label>

        <div>
          <strong>Co o tobě Drill vede a podmínky</strong>
          {docs.documents.map((d) => (
            <details key={d.key}>
              <summary>{d.title}</summary>
              <p>{d.text}</p>
            </details>
          ))}
        </div>

        {docs.checks.map((c) => (
          <label key={c.key} className="auth__label">
            <span>
              <input
                type="checkbox"
                checked={ticked[c.key]}
                onChange={(e) => setTicked({ ...ticked, [c.key]: e.target.checked })}
              />{' '}
              {c.label}
            </span>
            <small>{c.hint}</small>
          </label>
        ))}

        <p className="auth__subtitle">
          Drill si uloží datum a verzi potvrzení. Když se podmínky změní, ukáže je znovu.
        </p>

        {error && <p className="auth__error" role="alert">{error}</p>}

        <button className="button button--primary" type="submit" disabled={submitting}>
          {submitting ? 'Ukládám…' : 'Nastavit heslo'}
        </button>
      </form>
    </div>
  );
}
